
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { addInquirySheet } from "@/api/inquiry";
import { setRemark } from "@/api/supplier-payment";

@Component({
  name: "CreateFee",
})
export default class extends Vue {
  @Prop({ default: "付款单" }) private title: "";
  @Prop({ default: "" }) private id: "";
  @Prop({ default: {} }) private paymentForm: {} | any;

  @Watch("paymentForm", { immediate: true })
  private async watchData() {
    this.form = {
      relationPackingList: this.paymentForm.relationPackingList,
      relationPurchaseOrder: this.paymentForm.relationPurchaseOrder,
      remark: this.paymentForm.remark,
    };
  }

  private form = {
    relationPackingList: null,
    relationPurchaseOrder: null,
    remark: null,
  };

  private show = false;

  private close() {
    this.show = false;
    this.$emit("update:show", false);
  }

  private open() {
    this.show = true;
  }
  // 填写备注
  public async handleRemark() {
    try {
      await setRemark(this.id, {
        remark: this.form.remark,
      });
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      this.$emit("success", false);
    } catch (e) {
      this.$emit("success", false);
    }
  }

  private async submitForm(): Promise<void> {
    (this.$refs.ruleForm as any).$refs.ruleForm.validate(
      async (valid: boolean) => {
        if (valid) {
          try {
            this.addInquirySheet();
          } catch (error) {
            console.error(error);
          }
        }
      }
    );
  }

  private handleAdd() {
    this.show = true;
  }

  // 新建询价单
  private async addInquirySheet() {
    try {
      await addInquirySheet({});
      this.$notify({
        title: "成功",
        message: "创建成功",
        type: "success",
        duration: 2000,
      });
      this.close();
      this.$emit("success", false);
    } catch {}
  }
}
